
/// <reference types="signalr" />
import * as angular from 'angular';

import { CtrlDocumentInfo } from '../documentinfo/CtrlDocumentInfo';
import '@common/navkendo/infoma.kwidgets';
import { GetFileIcon } from '../KWFUtils';
import { IDocLink } from '@common/preview/preview.d';
import { fn } from '@common/utils';
import * as kutils from '@common/navkendo';
import { RWFPreviewController, GetDocLinks, RWFPreviewControllerCreated, PreviewInit, PreviewConfig } from './rwfpreviewcontroller'
/** Global APP Functionality (Shared between current Visualizations RoleCenter/Benutzerschreibtisch) */

//#region imports
import UISafe = fn.UISafe;
import { CompatibilityService } from '@services/compatibilityservice';
import { RwfInvoiceData, RwfInvoiceDataService } from '@common/rwf/rwfinvoicedata';
import { IPreviewFieldSetting, RwfAppSettings } from '@common/rwf/rwf.appsettings';
import { RwfAutoResolver } from '@common/rwf';
import { GetPropDisplayValue } from '@common/navkendo';
import { IPageMetaData, INavPageClientInfo, Observable } from '../navdata';
import { NavSearch } from '../userdesk/search';
import { SPAProxyController } from '../rwf.spa.proxy';
import { IPreviewConfig } from './rwfpreviewcontroller';
export { RwfInvoiceData, RwfInvoiceDataService };
//#endregion

/** Document Show/Preview Handling Service */
export class KWFPreviewService extends Observable {

    static GetInstance = () => <KWFPreviewService>angular.element(window.document).injector().get("KWFPreviewService");
    static $inject = ["CompatibilityService", "RwfAppSettings", "Rwf", "$rootScope"];

    constructor(
        readonly $c: CompatibilityService,
        public RwfAppSettings: RwfAppSettings,
        readonly $rwf: RwfAutoResolver,
        $rootScope: ng.IRootScopeService) {
            super();
        this.$scope = $rootScope.$new();

        // Hide Preview on Route Change
        $rootScope.$on("$routeChangeStart", this.HidePreview.bind(this, undefined));
        // var userSettings = this.userSettings = $c.resolve("NavSettings").CreateUserSettings(["KWF", "RwfPreview"]);

        // userSettings.Add("External", () => {
        //     return {
        //         Show : this.ShowExternal
        //     }
        // }, s => {
        //     this.ShowExternal = s?.Show;
        // });
        // userSettings.Load();
        // this.bind([ "ShowExternal" ], () => userSettings.Save());

    }
    private $scope: ng.IScope;

    _PreviewPopupBounds: { x, y, width, height: number };
    _lastPreviewRowItem: kendo.data.ObservableObject = null;

    /** Choose a supplement doc in a context menu for direct preview */
    ChooseRowItemSupplementDoc(evt: JQueryEventObject, rowitem?: any, colInfoSource?: IPreviewInformationSource, previewFieldType?: PreviewFieldsType) {
        const $rwf = this.$rwf;
        const $c = this.$c;
        rowitem = rowitem || kutils.GetRowItem(evt);
        colInfoSource = colInfoSource || kutils.GetGrid(evt);
        var colInfo = GetResolveColInformation(colInfoSource, previewFieldType);
        var isArchived = rowitem && !!rowitem.WorkflowID;

        // Open loading context menu
        var jqcm = $("<ul></ul>");
        $(document).add(jqcm);
        var cm = jqcm.kendoContextMenu({
            animation: <any>false,
            dataSource: {
                text: "Zusatzdokumente <img src='./loading.gif' style='position: relative; top: -1px; margin-left: 5px' />",
                encoded: false
            },
            target: $(evt.target),
            orientation: "horizontal",
            deactivate: closedEvt => {
                // Remove from DOM
                closedEvt.sender.destroy();
                jqcm.remove();
            }
        }).data("kendoContextMenu");
        cm.open(evt.pageX - 10, evt.pageY - 10);

        var openSubDocs = (docLinks: IDocLink[]) => {
            // Filter for supplement docs and transform to context menu item
            let miDocLinks = docLinks.filter(fe => (fe.Type || "").toString() === "2").map(v => {
                return {
                    text: v.Title,
                    imageUrl: GetFileIcon(v.Extension),
                    docurl: v.Url
                };
            });

            if (docLinks && docLinks.length > 0) {
                if (miDocLinks.length == 1) {
                    // Show the one and only supplement doc (no context menu necessary)
                    cm.trigger("deactivate");
                    window.setTimeout(() => {
                        // WTF ?!? wout Preview not available ....
                        let previewUrl = miDocLinks[0].docurl;
                        this._ShowRowItemInfoByData(rowitem, docLinks, previewUrl, colInfo);
                    });
                } else if (miDocLinks.length > 0) {
                    // Show supplement docs to choose from for direct preview
                    cm.setOptions({
                        // Subitems are bad to reach by mouse so move them to root
                        dataSource: [{
                            text: "Zusatzdokumente",
                            items: miDocLinks
                        }],
                        //dataSource: miDocLinks,
                        select: (selectEvt: kendo.ui.ContextMenuSelectEvent) => {
                            let clickedItem = $(selectEvt.item).closest(".k-item");
                            let hasSubElements = clickedItem.find(".k-item").length > 0;

                            if (!hasSubElements) {
                                let index = clickedItem.prevAll(".k-item").length;
                                if (index >= 0 && index < miDocLinks.length) {
                                    let selectedItem = miDocLinks[index];
                                    let previewUrl = selectedItem.docurl;

                                    // Open selected supplement doc
                                    this._ShowRowItemInfoByData(rowitem, docLinks, previewUrl, colInfo);
                                }
                            }
                        }
                    });
                } else {
                    cm.trigger("deactivate");
                }
            } else {
                cm.trigger("deactivate");
            }
        };

        var getDocLinks: PromiseLike<IDocLink[]>;
        if (isArchived) {
            // Resolve completed doc url
            getDocLinks = $c.when(CtrlDocumentInfo.GetArchiveDocumentsInfo($rwf, rowitem));
        } else {
            // Resolve running doc url
            getDocLinks = $rwf("RwfInvoiceData").Resolve.then(invoiceData => {
                return GetDocLinks(this.$c, rowitem, invoiceData);
            });
        }

        UISafe(
            getDocLinks.then(docLinks => {
                openSubDocs(docLinks);
            }).then(undefined, err => {
                //var errInfo = resolveToError(err);
                cm.trigger("deactivate");
                throw err;
            })
        );
    }

    ShowRowItemInfoByData(rowitem: any, colInfo: IPreviewInformationSource, settingPath?: PreviewFieldsType, previewUrl?: string) {
        this._ShowRowItemInfoByData(rowitem, null, previewUrl, GetResolveColInformation(colInfo, settingPath));
    }

    /** Show popover for row under mouse pointer  --> Statis as used in kendo templates */
    static ShowRowItemInfo(evt: JQueryEventObject, settingPath?: PreviewFieldsType) {
        const rowitem = kutils.GetRowItem(evt);
        const preview = KWFPreviewService.GetInstance();
        var columns = GetResolveColInformation(kutils.GetGrid(evt), settingPath);
        preview.ShowRowItemInfoByData(rowitem, columns);
    }

    private _ShowRowItemInfoByData(rowitem: kendo.data.ObservableObject, extDocUrls: IDocLink[], previewUrl?: string, colInfo?: IPreviewInformation): void {
        // Not quite clear why timeout is necessary in some situations [INF109600] .... (WTF -> refactor!)
        window.setTimeout(() => {
            let title = colInfo?.GetCaption ? colInfo?.GetCaption(rowitem) : "Vorschau";

            const config = this.lastConfig = {
                DisplayGroups: colInfo?.GetDisplayGroups(rowitem) || [],
                ExtDocUrls: extDocUrls,
                RowItem: rowitem,
                Title: title,
                PreviewUrl: previewUrl
            }

            if (this.ShowExternal) {
                this.SetCurrentData2Extern(config);
            } else {
                let kpopup = this.getPreviewPopup();
                kpopup.title(title);
                kpopup.open();
                this._previewCtrl?.SetCurrentData2Local(config);
            }
        });
    }
    private lastConfig: IPreviewConfig;

    SetCurrentData2Local(config: IPreviewConfig) {
        let kpopup = this.getPreviewPopup();
        kpopup.open();
        kpopup.title(config?.Title);
        this._previewCtrl?.SetCurrentData2Local(config);

    }

    async SetCurrentData2Extern(config: IPreviewConfig) {
        this.ShowExternal = true;
        const rowitem = config.RowItem;
        const externalPreview = this._externalPreview;
        config.RowItem = (rowitem instanceof kendo.data.ObservableObject) && rowitem.toJSON() ? rowitem.toJSON() as any : rowitem;

        if (!externalPreview.IsActive) {
            externalPreview.IsActive = true;
            externalPreview.ChangeRoute('/#/' + RWFPreviewController.RouteName);
            await new Promise((resolve, reject) => {
                externalPreview.one(PreviewInit, () => {
                    window.setTimeout(() => {
                    resolve();
                    this.$c.tick();
                });
                });
                window.setTimeout(() => reject("Failed to Init External Preview"), 10000);
            });
        }
        await externalPreview.SendObject(PreviewConfig, config);
        this.HidePreviewPopup();
    }

    HidePreview() {
        const externalPreview = this._externalPreview;
        if(externalPreview) {
            externalPreview.IsActive = false;
        }
        this.HidePreviewPopup();
    }

    private HidePreviewPopup() {
        var kpopup = this._previewPopup;
        if (kpopup && kpopup.wrapper.is(":visible")) {
            // Hide popup
            kpopup.close();
        }
    }

    /** get or Imp Create single instance window popup */
    getPreviewPopup() {
        if (!this._previewPopup) {
            let previewBounds = this._PreviewPopupBounds || (this._PreviewPopupBounds = (() => {
                var top = 20;
                var left = (window.event && (<MouseEvent>window.event).clientX || 0) + 20;
                var width = Math.max(Math.min($(window).width() - left - 40, 800), 400);
                var height = Math.max(Math.min($(window).height() - top - 55, 680), 400);
                return { x: left, y: 20, width: width, height: height };
            })()),
                fitWindowSize = () => { $(kpopup.wrapper).fitToOffsetParent(); },
                updatePopupSizeDebounced = fn.debounce(() => {
                    previewBounds.width = kpopup.wrapper.width();
                    previewBounds.height = kpopup.wrapper.height();

                    // Fit kendowindow size to window
                    this._previewPopup.wrapper.fitToOffsetParent();
                }, 1000),
                options = <kendo.ui.WindowOptions>{
                    actions: ["hyperlink-open", "Close"],
                    animation: false,
                    visible: false,
                    position: { top: previewBounds.y, left: previewBounds.x },
                    width: previewBounds.width,
                    height: previewBounds.height,
                    title: "Vorschau",
                    close: (e: kendo.ui.WindowCloseEvent) => {
                        // Don't close
                        e.preventDefault();
                        // Just hide
                        e.sender.wrapper.hide();
                        $(window).off("resize.popup", fitWindowSize);
                        this._previewCtrl?.Reset(true);
                    },
                    open: (e) => {
                        $(window).on("resize.popup", fitWindowSize);
                        // Fitsize on window open
                        fitWindowSize();
                    },
                    dragend: e => {
                        // Remember new position
                        var newpos = e.sender.wrapper.offset();
                        previewBounds.x = newpos.left;
                        previewBounds.y = newpos.top;
                    },
                    resize: updatePopupSizeDebounced
                };

            // Add popup to DOM if not present yet
            let popup = $("<div></div>");
            $("#idms_MainContentView").append(popup);

            // tis way we make popupContent 'angular active' (the kendo way)
            options["$angular"] = [this.$scope];
            popup.kendoWindow(options); // Needs options - flickers otherwise
            var kpopup = this._previewPopup = popup.data("kendoWindow");
            kpopup.wrapper.find(".k-window-actions [aria-label='hyperlink-open']").attr("title", "In separatem Fenster öffnen").bind("click.navCustom", (e) => {
                e.preventDefault();
                this.SetCurrentData2Extern(this.lastConfig);
            }).parent().removeAttr("href"); // href : s.times href='#' ...;

            this.$scope.$on(RWFPreviewControllerCreated, (e, ctrl) => {
                this._previewCtrl = (ctrl instanceof RWFPreviewController) && ctrl;
                this.SetCurrentData2Local(this.lastConfig);
            });
            kpopup.content("<rwfpreview></rwfpreview>");
            kpopup.open();
            this.$c.tick();
        }
        return this._previewPopup;
    }
    private _previewPopup: kendo.ui.Window;
    private _previewCtrl: RWFPreviewController;
    private _externalPreview?: SPAProxyController;

    public get ShowExternal() { return this._showExternal; }
    public set ShowExternal(value: boolean) {
        if(value !== this._showExternal) {
            this._showExternal = value;

            if(value && !this._externalPreview) {
                this._externalPreview = SPAProxyController.TryInstantiate(this.$c, "ExternalPreview");
            }
        }
    }
    private _showExternal: boolean;
}

export type PreviewFieldsType = "Invoice" | "Search";
export type IPreviewInformationSource = IPreviewInformation | IPageMetaData | kendo.ui.Grid;

interface IPreviewInformation {
    GetCaption: (obj: any) => string;
    GetDisplayGroups(obj: any): { Label: string, Value: string }[][];
}

// TODO: Refactor (further) ...
function GetResolveColInformation(colSource?: IPreviewInformationSource, type?: PreviewFieldsType): IPreviewInformation {
    type IGetValue = (obj: any, names: string | string[]) => string;

    const setting = PreviewFields[type] || PreviewFields["Search"];

    function First<T>(item: T | T[], getter: (item: T) => string) {
        var result: string;
        ToArray(item).forEach(item => {
            result = result || getter(item);
        });
        return result;
    }
    function ToArray<T>(item: T | T[]) {
        if (Array.isArray(item)) {
            return item;
        }
        return (item && [item]) || [];
    }
    function GetCaption(rowitem: any, fields: string[], getValue: IGetValue) {
        if (rowitem && fields?.length > 0) {
            return "Vorschau: " + fields?.map(value => getValue(rowitem, value)).filter(fn.isSet).join(" ") || "";
        }
    };

    function GetDisplayGroups(rowitem, getTitle: (propname: string) => string, getValue: IGetValue) {
        var fieldColGroups = setting && setting.Content;
        /** the actual info bound to Popup Scope */
        return fieldColGroups.map(colGroup => {
            return colGroup.map(propName => {
                const colTitle = First(propName, propName => getTitle(propName));
                if (colTitle && rowitem) {
                    return {
                        Label: colTitle,
                        Value: getValue(rowitem, propName)
                    };
                }
            }).filter(fn.isSet);
        }).filter(group => group.length > 0);
    }

    if (colSource instanceof kendo.ui.Grid) {
        // TODO: Refactor!
        var ng = colSource.options["$angular"];
        var scope = ng && ng[0] && ng[0][NavSearch];
        var navClient = scope && scope[colSource.element.attr("kendo-nav-grid").substr(3)]?.PageClient as INavPageClientInfo;
        if (navClient?.MetaData) {
            colSource = navClient.MetaData;
        } else {
            const columns = colSource.options.columns;
            var dict = fn.ToDictionary(columns, "field");
            const getValue: IGetValue = (obj: any, name: string | string[]) => First(name, name => kutils.GetDisplayValue(dict[name], obj));
            return {
                GetCaption: (rowitem) => GetCaption(rowitem, setting?.Title, getValue),
                GetDisplayGroups: (rowitem) => GetDisplayGroups(rowitem, propName => dict[propName]?.title,
                    getValue)
            };
        }
    }

    function isPageMetaData(colSource: any): colSource is IPageMetaData {
        var t: IPageMetaData = colSource;
        return t && t.PropsByName && t.PageName && !!t.GetClientKey;
    }

    function Get(colSource: IPageMetaData) {
        const ResolveProperty = (name: string) => colSource.ResolveProperty(name, false, true);
        const getValue: IGetValue = (obj: any, name: string) => {
            const p = ResolveProperty(name);
            return p && obj && GetPropDisplayValue(obj[p.Name], p);
        };
        return {
            GetCaption: (rowitem) => GetCaption(rowitem, (setting?.Title || []).map(item => ResolveProperty(item)?.Name).filter(fn.isSet), getValue),
            GetDisplayGroups: rowitem => GetDisplayGroups(rowitem,
                (name) => colSource.ResolveProperty(name, false, true)?.Title,
                getValue)
        };
    }
    if (isPageMetaData(colSource)) {
        return Get(colSource);
    }

    if (colSource?.GetCaption && colSource?.GetDisplayGroups) {
        return colSource;
    }

    return {
        GetCaption: fn.noop,
        GetDisplayGroups: fn.noop
    };
}

const PreviewFields: Record<PreviewFieldsType, IPreviewFieldSetting> = {
    Invoice: {
        Title: ['Name'],
        Content: [['Accounting', 'DocumentType', 'Name', 'Adress', 'Post_Code', 'City', 'IBAN'], ['Receipt_Date', 'Document_Date', 'Due_Date'], ['Amount', 'External_Document_No', 'Posting_Description'], ['CurrentWorkflowPart_Name', 'CurrentWorkflowStep_Name', 'CheckedOutBy', 'CheckedOutSince', 'Created']]
    },
    Search: {
        Title: ['_Name'],
        Content: [['Document_Type', 'Document_No', 'Name_Adresse', 'IBAN'], ['Document_Date', 'Due_Date', 'Posting_Date'], ['Amount', 'Remaining_Amount', 'Open', 'Reversed'], ['External_Document_No', 'Description', 'Erweiterter_Belegtext']]
    }
};
